import React from "react";

const AIBanner = () => {
  return (
    <div className="ai-banner">
      These activities are AI-powered suggestions to enhance your experience!
    </div>
  );
};

export default AIBanner;
